import type { GameMetrics } from '@completto/shared';
import { html, View } from 'rune-ts';

export type GameStatsData = {
  metrics: GameMetrics;
};

export class GameStatsView extends View<GameStatsData> {
  override template() {
    const { metrics } = this.data;
    const durationText = formatDurationFromMetrics(metrics);

    return html`
      <section class="game-stats flex flex-col gap-2 rounded-xl bg-wood-paper ring-1 ring-wood-sand p-4 w-full">
        <h2 class="text-sm text-wood-coffee/70">게임 통계</h2>
        <div class="flex items-center justify-between">
          <span class="text-sm text-wood-coffee">게임 시간</span>
          <span class="text-base font-semibold tabular-nums text-wood-ink">${durationText}</span>
        </div>
      </section>
    `;
  }
}

function formatDurationFromMetrics(metrics: GameMetrics): string {
  if (metrics.startedAt <= 0 || metrics.finishedAt === null) return '—';
  const ms = Math.max(0, metrics.finishedAt - metrics.startedAt);
  return formatDuration(ms);
}

export function formatDuration(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  if (totalSeconds < 60) return `${totalSeconds}초`;
  const totalMinutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (totalMinutes < 60) return `${totalMinutes}분 ${seconds}초`;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}시간 ${minutes}분`;
}
